import { render, staticRenderFns } from "./rich-editor-widget.vue?vue&type=template&id=0f32d032&scoped=true"
import script from "./rich-editor-widget.vue?vue&type=script&lang=js"
export * from "./rich-editor-widget.vue?vue&type=script&lang=js"
import style0 from "./rich-editor-widget.vue?vue&type=style&index=0&id=0f32d032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32d032",
  null
  
)

export default component.exports